<template>
  <b-container class="horaires">
    <h1 class="titre">Présentation de nos services :</h1>
    <div class="rangee_services">
      <i class="fas fa-exclamation-circle fa-7x"></i>
      <hr class="separator"/>
      <div class="row">
        <div class="col-md-4 col-12 service">
          <h2 class="titre_service">Services 1-7-9</h2>
          <span class="texte_service">
          Ligne Express qui relie Château-Salins à Metz en moins d’une heure en desservant ses arrêts majeurs dès 6h
          du matin
        </span>
        </div>
        <div class="col-md-4 col-12 service">
          <h2 class="titre_service">Services 11-13-15</h2>
          <span class="texte_service">
          Ligne régulière qui dessert chaque arrêt de la ligne Château-Salins - Metz, réservable sur simple appel
        </span>
        </div>
        <div class="col-md-4 col-12 service">
          <h2 class="titre_service">Services 3-17</h2>
          <span class="texte_service">
          Ligne TAD, le transport à la demande en véhicule léger réservable sur simple appel
        </span>
        </div>
      </div>
    </div>

    <div class="div_lien_horaire">
      <a class="lien_horaire" target="_blank"
         href="https://drive.google.com/file/d/17XKRdPT5K_-5KThXmzXt_jE7yMOennZC/view">
        <b-btn class="grille_horaire">Consulter la grille horaire</b-btn>
      </a>
    </div>
  </b-container>
</template>

<script>
  export default {
    name: 'Horaires'
  }
</script>

<style lang="scss">
@import "src/sass/app";

.horaires {
  .titre {
    margin: 3rem 0;
    text-align: center;
    font-family: $titlefont;
    color: $firstcolor;
    font-size: 50px;
  }

  .rangee_services {
    text-align: center;
    background-color: $firstcolor;
    border-radius: 15px;
    padding: 3rem;
    color: white;
    @include media-breakpoint-down(xs) {
      margin: 0 0.1rem;
    }

    .separator {
      background-color: white;
      // height: 2px;
    }
    .service {
      padding: 0 2rem;
      @include media-breakpoint-down(sm) {
        margin: 2.5rem 0;
      }
      @include media-breakpoint-up(md) {
        margin-top: 2.5rem;
      }
      .titre_service {
        font-family: $titlefont;
        font-size: 30px;
        font-weight: bold;
      }
      .texte_service {
        font-family: $textfont;
        font-size: 18px;
        text-align: justify;
      }
    }
  }

  .div_lien_horaire {
    display: flex;
    margin: 2rem 0;
    .lien_horaire {
      margin: auto;
      .grille_horaire {
        font-size: 25px;
        text-transform: uppercase;
        padding: 2rem;
        background-color: white;
        color: $secondcolor;
        border: 2px solid $secondcolor;
      }
      .grille_horaire:hover {
        background-color: $secondcolor;
        color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Horaires.vue